<template>
    <v-row>
        <v-col cols="12">
            <div class="text-center grey--text darken-2">Sponsors</div>
            <div class="d-flex justify-center">
                <advertisement v-for="advertisement in ads" :key="advertisement.id" :ad="advertisement" />
            </div>
        </v-col>
    </v-row>
</template>

<script>
import Advertisement from '@/Components/Advertisements/Advertisement.vue';

export default {
    name: 'Advertisements',

    components: { Advertisement },

    props: {
        ads: {
            type: Array,
            required: true,
        },
    },

    computed: {
        maxWidth() {
            if (this.ads.length === 0) {
                return null;
            }

            return this.ads
                .map(ad => Number.parseInt(ad.width, 10))
                .sort()
                .reverse()[0];
        },

        maxHeight() {
            if (this.ads.length === 0) {
                return null;
            }

            return this.ads
                .map(ad => Number.parseInt(ad.height, 10))
                .sort()
                .reverse()[0];
        },

        style() {
            const style = { 'justify-content': 'center' };

            if (this.maxWidth) {
                style['min-width'] = this.maxWidth;
            }

            if (this.maxHeight) {
                style['min-height'] = this.maxHeight;
            }

            return style;
        },
    },
};
</script>
